import type { GroupBase, StylesConfig } from "react-select";

import newTheme from "@/new_theme";
import { i18n } from "@lingui/core";

const KEYWORD_MIN_LENGTH = 2;
const WILDCARD_KEYWORD_MIN_LENGTH = 3;

const FIELD_TO_LABEL_MAP: Record<string, string> = {
  title: L.MENTIONS_QUERYBUILDER_TITLE_LABEL,
  search_type: L.MENTIONS_QUERYBUILDER_MODAL_TYPE_LABEL,
  start_date: L.MENTIONS_QUERYBUILDER_START_DATE_LABEL,
  end_date: L.MENTIONS_QUERYBUILDER_END_DATE_LABEL,
  sorting_position: L.MENTIONS_QUERYBUILDER_FILTER_SORTING_POSITION,
};

export const validateKeyword = (word: string) => {
  const withoutWildcards = word.replaceAll(/\*/g, "");
  if (withoutWildcards.length < word.length) {
    return withoutWildcards.length >= WILDCARD_KEYWORD_MIN_LENGTH;
  }
  return withoutWildcards.length >= KEYWORD_MIN_LENGTH;
};

type QueryError = {
  non_field_errors?: string[];
};

type ValidationErrorsInput = {
  queries?: QueryError[];
} & Record<string, unknown>;

export const validationErrors = (data: ValidationErrorsInput): string[] => {
  const errors: Array<string> = [];

  Object.keys(FIELD_TO_LABEL_MAP).forEach((field) => {
    if (field in data) {
      errors.push(i18n._(FIELD_TO_LABEL_MAP[field]));
    }
  });

  if (data?.queries) {
    data.queries.forEach((queryError, i) => {
      if (queryError.non_field_errors) {
        queryError.non_field_errors.forEach((fieldError) => {
          errors.push(
            `${L.MENTIONS_QUERYBUILDER_SAVE_FAILED_QUERY} ${
              i + 1
            }: ${fieldError}`
          );
        });
      }
    });
  }

  return errors;
};

type Option = { label: string; value: string };

export const getCustomStyles = (
  fieldName?: string
): StylesConfig<Option, true, GroupBase<Option>> => ({
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: "1rem",
  }),

  multiValue: (provided) => {
    const style = {
      ...provided,
      borderRadius: "0.2rem",
    };

    if (fieldName === "nearKeywords" || fieldName === "nearNearKeywords") {
      return {
        ...style,
        backgroundColor: newTheme["green-100"],
        color: newTheme["green-800"],
      };
    }
    if (fieldName === "notNearKeywords") {
      return {
        ...style,
        backgroundColor: newTheme["red-100"],
        color: newTheme["red-800"],
      };
    }

    return style;
  },

  valueContainer: (provided) => ({
    ...provided,
    paddingRight:
      fieldName && ["nearKeywords", "notNearKeywords"].includes(fieldName)
        ? "2rem"
        : undefined,
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  dropdownIndicator: () => ({
    display: "none",
  }),
});
